export default __webpack_public_path__ + "static/media/Arm Guard of the Warded Brute.be8c2061.jpg";